import { Inject, Injectable } from '@angular/core';
import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG } from '../config';
import { FeatureTogglesDataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { CookieService } from 'ngx-cookie-service';

const CLASS_NAME = 'FeatureTogglesDao';

@Injectable()
export class FeatureTogglesDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.featureTogglesDAO, new DefaultRetryHandler(), new FeatureTogglesDataValidator(), log, cookieService);
  }

  get(): Observable<any> {
    let featureToggleRequestURL = `${this.daoConfig.url}`;
    const teamVMCookieName = 'stay-mgmt';
    const environmentQueryParam = '?environment=';

    if (featureToggleRequestURL.indexOf(environmentQueryParam) === -1) {
      const teamVMCookieValue = getCookie(teamVMCookieName);
      if (teamVMCookieValue) {
        featureToggleRequestURL = featureToggleRequestURL.concat(environmentQueryParam + teamVMCookieValue);
      }
    }

    function getCookie(name: string): string {
      const nameLenPlus = (name.length + 1);
      return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    }

    const url = featureToggleRequestURL;
    return super.doGet(url);
  }

};



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/feature-toggles.dao.ts